(ns renolit-roofing-service.util.interop)

(defprotocol JsInteropDataEnvelope
  (envelope->value [this]))

(deftype js-interop-data-envelope [value]
  JsInteropDataEnvelope
  (envelope->value [_this]
    value)

  IEncodeJS
  (-clj->js [x]
    x)
  (-key->js [x]
    x))
